import { useParams, useNavigate } from "react-router-dom";
import { ALGORITHMS } from "../data/algorithmsData";
import { useState } from "react";
import * as Icons from "lucide-react";
import { ArrowLeft, ChevronRight, Activity } from "lucide-react";
import { DetailDrawer } from "../components/DetailDrawer";

const Icon = ({ name, className, color }) => {
  const C = Icons[name] || Icons.Circle;
  return <C className={className} style={{ color }} strokeWidth={1.5} />;
};

export default function AlgorithmDetail() {
  const { platform } = useParams();
  const nav = useNavigate();
  const algo = ALGORITHMS[platform];
  const [openPhase, setOpenPhase] = useState(null);

  if (!algo) {
    return (
      <div className="text-center py-20">
        <p className="text-zinc-400 mb-4">Plateforme inconnue.</p>
        <button onClick={() => nav("/algorithmes")} className="text-[#CCFF00] underline">Retour au hub</button>
      </div>
    );
  }

  return (
    <div className="space-y-8 animate-fadeUp" data-testid={`algo-detail-${platform}`}>
      <button onClick={() => nav("/algorithmes")} className="flex items-center gap-2 text-[10px] font-mono uppercase tracking-wider text-zinc-500 hover:text-[#CCFF00] transition" data-testid="back-to-hub">
        <ArrowLeft className="w-3 h-3" /> Retour aux algorithmes
      </button>

      <header className="flex items-start gap-5">
        <div className="w-14 h-14 rounded-sm flex items-center justify-center border shrink-0" style={{ background: `${algo.color}15`, borderColor: `${algo.color}40` }}>
          <Icon name={algo.icon} className="w-7 h-7" color={algo.color} />
        </div>
        <div className="border-l-2 border-[#CCFF00] pl-5 flex-1">
          <div className="text-[10px] font-mono uppercase tracking-[0.2em] mb-2" style={{ color: algo.color }}>// ALGORITHME {algo.name.toUpperCase()}</div>
          <h1 className="font-display text-4xl sm:text-5xl font-bold text-white tracking-tight">{algo.name}</h1>
          <p className="text-zinc-400 mt-2 max-w-3xl">{algo.tagline}</p>
        </div>
      </header>

      <div className="border border-[#1E1E24] bg-[#0A0A0C] rounded-sm p-6 max-w-4xl">
        <div className="text-[10px] font-mono uppercase tracking-[0.18em] text-zinc-500 mb-3">// VUE D'ENSEMBLE</div>
        <p className="text-zinc-200 leading-relaxed">{algo.overview}</p>
      </div>

      <section>
        <h2 className="font-display text-2xl font-semibold text-white mb-5">Phases du push algorithmique</h2>
        <div className="space-y-3">
          {algo.phases.map((phase, i) => (
            <button
              key={phase.id}
              onClick={() => setOpenPhase(phase)}
              data-testid={`phase-${phase.id}`}
              className="w-full text-left group border border-[#1E1E24] hover:border-[#CCFF00]/40 bg-[#0A0A0C] hover:bg-[#0C0C0E] rounded-sm p-5 transition-all flex items-center gap-5"
            >
              <div className="font-mono text-3xl font-medium" style={{ color: algo.color }}>
                {String(i + 1).padStart(2, "0")}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-display text-lg font-semibold text-white">{phase.title}</div>
                <div className="text-xs font-mono uppercase tracking-wider text-zinc-500 mt-1">{phase.range}</div>
                <p className="text-sm text-zinc-400 mt-2 leading-relaxed line-clamp-2">{phase.intro}</p>
              </div>
              <div className="flex items-center gap-2 text-[10px] font-mono uppercase tracking-wider text-[#CCFF00] shrink-0 group-hover:gap-3 transition-all">
                <Activity className="w-3 h-3" />
                <span>Détails</span>
                <ChevronRight className="w-3 h-3" />
              </div>
            </button>
          ))}
        </div>
      </section>

      <DetailDrawer
        open={!!openPhase}
        onOpenChange={(o) => !o && setOpenPhase(null)}
        title={openPhase?.title || ""}
        subtitle={openPhase?.range}
        details={openPhase ? {
          intro: openPhase.intro,
          stats: openPhase.stats,
          actions: openPhase.actions,
          checklist: openPhase.checklist,
          kpis: openPhase.kpis,
          errors: openPhase.errors,
          proTips: openPhase.proTips,
          examples: openPhase.examples,
        } : null}
        aiContext={openPhase ? {
          topic: `${algo.name} — ${openPhase.title}`,
          context: `Phase: ${openPhase.range}. Objectif: ${openPhase.intro}. Donne du contenu encore plus concret et niche-agnostic.`,
          platform: algo.name
        } : null}
      />
    </div>
  );
}
